// Librairies
import { DestroyRef, Directive, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GoogleMap } from '@angular/google-maps';

// Services
import { ThemeService } from 'src/app/services/core/theme/theme.service';

// Variables
const DARK_THEMES: readonly string[] = ['dark-theme', 'midnight-theme'];

// Dark map tinted dark green like the Unifield dark themes, light enough to read the land, the water and the roads.
export const DARK_MAP_STYLES: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#343a30' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#2a2f27' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#a9b19c' }] },
  { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#6b7360' }] },
  { featureType: 'administrative.country', elementType: 'labels.text.fill', stylers: [{ color: '#d2d8c6' }] },
  { featureType: 'administrative.locality', elementType: 'labels.text.fill', stylers: [{ color: '#c4cbb6' }] },
  { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#3a4234' }] },
  { featureType: 'poi', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ visibility: 'on' }, { color: '#3f4a36' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#4c5544' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#3a4234' }] },
  { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#5d6852' }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'transit', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#22333a' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#6f8790' }] },
];

// Classes
export function mapStyles(theme: string): google.maps.MapTypeStyle[] {
  return DARK_THEMES.includes(theme) ? DARK_MAP_STYLES : [];
}

// On a <google-map>: the dark map in the dark and midnight themes, following a theme change.
@Directive({
  selector: 'google-map[appMapTheme]',
  standalone: true
})
export class MapThemeDirective {
  // Services
  private readonly map: GoogleMap = inject(GoogleMap);
  private readonly themeService: ThemeService = inject(ThemeService);

  constructor() {
    effect(() => this.apply(this.themeService.theme()));
    this.map.mapInitialized.pipe(takeUntilDestroyed(inject(DestroyRef))).subscribe(() => this.apply(this.themeService.theme()));
  }

  private apply(theme: string): void {
    this.map.googleMap?.setOptions({ styles: mapStyles(theme) });
  }
}
